"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeEnvLoadService = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const ioredis_1 = __importDefault(require("ioredis"));
const dimensions_helpers_1 = require("./dimensions.helpers");
const typing_1 = require("./typing");
class BeEnvLoadService {
    constructor(optionsOrInstance) {
        if (optionsOrInstance instanceof ioredis_1.default) {
            this.redis = optionsOrInstance;
        }
        else {
            this.redis = new ioredis_1.default(optionsOrInstance);
        }
    }
    /**
     * Gets environment variables from Redis for object containing all dimensions.
     * Some dimensions are optional.
     * Required dimensions: module, brand|brandCode, language, market, envName
     * Optional dimensions: brand|brandCode, context, version
     * @param dimensions dimensions for which to get ENVs
     */
    getEnvsForDimensions(dimensions) {
        return __awaiter(this, void 0, void 0, function* () {
            // try getting missing dimensions from known or set defaults
            dimensions = dimensions_helpers_1.processDimensions(dimensions);
            // validate required
            if (!dimensions.module) {
                throw new Error('Please specify module in dimensions - spc-backend for example');
            }
            if (!dimensions.brandCode) {
                throw new Error('Please specify brandCode or brand in dimensions - AC or citroen for example');
            }
            if (!dimensions.language) {
                throw new Error('Please specify language in dimensions - en for example');
            }
            if (!dimensions.market) {
                throw new Error('Please specify language in dimensions - gb for example');
            }
            if (!dimensions.envName) {
                throw new Error('Please specify envName in dimensions - qa for example');
            }
            if (!dimensions.meaning) {
                throw new Error('Please specify meaning in dimensions - backend/frontend');
            }
            const key = dimensions_helpers_1.getCacheKeyForDimensions(dimensions);
            return yield this._getEnvsForDimensionsCacheKey(key);
        });
    }
    /**
     * Gets environment variables from Redis for HTTP headers containing dimensions headers or full dimensions key
     * Some dimensions are optional.
     * Required dimension headers: x-brand-code, x-language, x-market, x-env-name
     * Optional dimension headers: x-context, x-api-version
     * @param headers [header name]: [header value] keypair object
     * @param module module for which to get ENVs for - required if dimensions key not supplied in headers
     * @param version optional version of module for which to get ENVs for, default from DefaultApiVersions is used otherwise. v1 for example
     */
    getEnvsFromHttpHeaders(headers, module, version) {
        return __awaiter(this, void 0, void 0, function* () {
            if (headers[typing_1.MMHeaders.DIMENSIONS_KEY]) {
                return yield this._getEnvsForDimensionsCacheKey(headers[typing_1.MMHeaders.DIMENSIONS_KEY]);
            }
            if (!module) {
                throw new Error('Please specify module to function, because whole dimensions key was not supplied');
            }
            const dimensions = dimensions_helpers_1.getRawDimensionsFromHeaders(headers);
            dimensions.module = module;
            if (!dimensions.version) {
                dimensions.version =
                    version || typing_1.DefaultApiVersions[dimensions.module];
            }
            return this.getEnvsForDimensions(dimensions);
        });
    }
    /**
     * Gets environment variables from Redis for HTTP headers containing dimensions headers or full dimensions key
     * Some dimensions are optional.
     * Required dimension headers: X_BRAND_CODE, X_LANGUAGE, X_MARKET, X_ENV_NAME
     * Optional dimension headers: X_CONTEXT, X_API_VERSION
     * @param env [environment variable name]: [environment variable value] keypair object
     * @param module module for which to get ENVs for - required if dimensions key not supplied in headers
     * @param version optional version of module for which to get ENVs for, default from DefaultApiVersions is used otherwise. v1 for example
     */
    getEnvsFromEnv(env, module, version) {
        var _a;
        if (env === void 0) { env = (_a = window_or_global_1.default
            .process) === null || _a === void 0 ? void 0 : _a.env; }
        return __awaiter(this, void 0, void 0, function* () {
            if (!env) {
                throw new Error('Please supply environments as object');
            }
            if (env[typing_1.MMEnvironmentVariables.DIMENSIONS_KEY]) {
                return yield this._getEnvsForDimensionsCacheKey(env[typing_1.MMEnvironmentVariables.DIMENSIONS_KEY]);
            }
            if (!module) {
                throw new Error('Please specify module to function, because whole dimensions key was not supplied');
            }
            const dimensions = dimensions_helpers_1.getRawDimensionsFromEnv(env);
            dimensions.module = module;
            if (!dimensions.version) {
                dimensions.version =
                    version || typing_1.DefaultApiVersions[dimensions.module];
            }
            return this.getEnvsForDimensions(dimensions);
        });
    }
    _getEnvsForDimensionsCacheKey(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const envJson = yield this.redis.get(key);
            if (envJson === null) {
                throw new Error(`Could not get ENVs from Redis using key ${key}`);
            }
            const envs = JSON.parse(envJson);
            return envs;
        });
    }
}
exports.BeEnvLoadService = BeEnvLoadService;
